/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M14 6L11 9"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14 18L8 12L11 9"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M9.13137 10.8686C8.73535 11.2646 8.53735 11.4627 8.46316 11.691C8.3979 11.8918 8.3979 12.1082 8.46316 12.309C8.53735 12.5373 8.73535 12.7354 9.13137 13.1314L12.2686 16.2686C13.1254 17.1254 13.5538 17.5538 13.9215 17.5827C14.2407 17.6078 14.5525 17.4786 14.7604 17.2352C15 16.9547 15 16.3489 15 15.1373V8.86274C15 7.65111 15 7.04529 14.7604 6.76477C14.5525 6.52136 14.2407 6.39218 13.9215 6.4173C13.5538 6.44624 13.1254 6.87462 12.2686 7.73137L9.13137 10.8686Z"
				fill="currentColor"
			/>
			<path
				d="M9.13137 10.8685C8.73535 11.2645 8.53735 11.4625 8.46316 11.6909C8.3979 11.8917 8.3979 12.1081 8.46316 12.3089C8.53735 12.5372 8.73535 12.7352 9.13137 13.1312L12.2686 16.2685C13.1254 17.1253 13.5538 17.5536 13.9215 17.5826C14.2407 17.6077 14.5525 17.4785 14.7604 17.2351C15 16.9546 15 16.3488 15 15.1371L15 8.86262C15 7.65099 15 7.04517 14.7604 6.76464C14.5525 6.52123 14.2407 6.39206 13.9215 6.41717C13.5538 6.44612 13.1254 6.8745 12.2686 7.73125L9.13137 10.8685Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M9.13137 10.8685C8.73535 11.2645 8.53735 11.4625 8.46316 11.6909C8.3979 11.8917 8.3979 12.1081 8.46316 12.3089C8.53735 12.5372 8.73535 12.7352 9.13137 13.1312L12.2686 16.2685C13.1254 17.1253 13.5538 17.5536 13.9215 17.5826C14.2407 17.6077 14.5525 17.4785 14.7604 17.2351C15 16.9546 15 16.3488 15 15.1371V8.86262C15 7.65099 15 7.04517 14.7604 6.76464C14.5525 6.52123 14.2407 6.39206 13.9215 6.41717C13.5538 6.44612 13.1254 6.8745 12.2686 7.73125L9.13137 10.8685Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M14 6L8 12M14 18L10 14"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M14 6L8 12L14 18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.13137 10.8685C8.73535 11.2645 8.53735 11.4625 8.46316 11.6909C8.3979 11.8917 8.3979 12.1081 8.46316 12.3089C8.53735 12.5372 8.73535 12.7352 9.13137 13.1312L12.2686 16.2685C13.1254 17.1253 13.5538 17.5536 13.9215 17.5826C14.2407 17.6077 14.5525 17.4785 14.7604 17.2351C15 16.9546 15 16.3488 15 15.1371V8.86262C15 7.65099 15 7.04517 14.7604 6.76464C14.5525 6.52123 14.2407 6.39206 13.9215 6.41717C13.5538 6.44612 13.1254 6.8745 12.2686 7.73125L9.13137 10.8685Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
